const TROPHY_SYMBOL = "🏆";

const TROPHY_LABELS = new Map([
  [1, "1st place trophy"],
  [2, "2nd place trophy"],
  [3, "3rd place trophy"],
]);

export function getLeaderboardTrophy(rank) {
  const place = Number(rank);
  const label = TROPHY_LABELS.get(place);
  if (!label) {
    return null;
  }

  return {
    className: `leader-trophy place-${place}`,
    label,
    symbol: TROPHY_SYMBOL,
  };
}
